import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { dcTag } from './model/dcTag.model';
import { coreStoreSelectors } from './store/core-store.selectors';
import { TagService } from './tag.service';

@Injectable()
export class UserProfileService {
  constructor(private store: Store, private tagService: TagService) {}

  public getStoreApps(isAppStore = true): Observable<dcTag[]> {
    if (isAppStore) {
      return this.getUserProfileApps();
    } else {
      return this.getUserApps();
    }
  }

  public getUserProfileApps(): Observable<dcTag[]> {
    return this.store.select(coreStoreSelectors.selectUserMenuTags);
  }

  public saveUserProfileApps(userMenuTags: dcTag[]) {
    return this.tagService.SaveUserFavoriteApps(userMenuTags).pipe(
      map(result => {
        if (result && result.Status) {
          return userMenuTags;
        } else {
          return [] as dcTag[];
        }
      })
    );
  }

  private getUserApps(): Observable<dcTag[]> {
    return this.store
      .select(coreStoreSelectors.selectCoreState)
      .pipe(map(state => (state.userDetails ? state.userDetails.UserApps : state.userMenuTags)));
  }
}
